module.exports = __webpack_public_path__ + "static/media/message_icons.2a582e59.svg";